import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { de } from 'date-fns/locale';

// Komponenten importieren
import OSPFragebogen from './components/OSPFragebogen';
import OSPAdmin from './components/OSPAdmin';
import LandingPage from './components/LandingPage';
import NotFound from './components/NotFound';
import ProtectedRoute from './components/ProtectedRoute';

// Theme-Konfiguration
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: [
      'Roboto',
      'Arial',
      'sans-serif'
    ].join(','),
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#f5f5f5',
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
        <Router>
          <Routes>
            {/* Startseite */}
            <Route path="/" element={<LandingPage />} />
            
            {/* Fragebogen-Route mit UUID und Session-ID */}
            <Route path="/fragebogen/:uuid/:sessionId" element={<OSPFragebogen />} />
            
            {/* Admin-Bereich (geschützt) */}
            <Route 
              path="/admin/*" 
              element={
                <ProtectedRoute>
                  <OSPAdmin />
                </ProtectedRoute>
              } 
            />
            
            {/* 404-Seite */}
            <Route path="/404" element={<NotFound />} />
            
            {/* Alle unbekannten Routen auf 404 umleiten */}
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </Router>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;